import { useCallback, useState } from "react"

export const useSessionStorage = (key: string, initialState: string) => {
	const [value, setValue] = useState(sessionStorage.getItem(key) ?? initialState)

	const updatedSetValue = useCallback(
		(newValue: string) => {
			if (newValue === initialState || typeof newValue === "undefined") {
				sessionStorage.removeItem(key)
			} else {
				sessionStorage.setItem(key, newValue)
			}
			setValue(newValue ?? initialState)
		},
		[initialState, key],
	)

	return [value, updatedSetValue] as const
}
